module.exports = __webpack_public_path__ + "assets/aaaf83e42aed833ac2bcbb733ffc7e1b.png";